import React from "react";

const customerRoute = [
  //Wastes
  {
    key: "waste-list",
    path: "/user-wastes/waste-list",
    component: React.lazy(() => import("views/Customer/wastes/WasteList")),
    authority: [],
  },
  {
    key: "add-waste",
    path: "/user-wastes/waste-list/add-waste",
    component: React.lazy(() => import("views/Customer/wastes/AddWaste")),
    authority: [],
  },
  {
    key: "edit-waste",
    path: "/user-wastes/waste-list/edit-waste/:wasteId",
    component: React.lazy(() => import("views/Customer/wastes/EditWaste")),
    authority: [],
  },
  //Gift Cards
  {
    key: "gift-cards",
    path: "/user/gift-cards",
    component: React.lazy(() => import("views/Customer/giftcards")),
    authority: [],
  },
];

export default customerRoute;
